<template>
  <div>
    <dl class="row mb-0">
      <dt class="col-sm-12">Logs</dt>
    </dl>
    <template v-for="item in getSortedArray">
      <b-card class="vsa-card-border-gray mb-2">
        <template v-for="(element, key) in item">
          <dl class="row mb-0">
            <dt class="col-sm-4 fs-900 fw-500 mb-0">
              {{ fnGetSnakeToTitle(key) }}
            </dt>
            <dd class="col-sm-8 fs-900 mb-0">
              <template>
                <span v-if="key == 'note'" v-html="element"></span>
                <span v-else-if="key == 'url'"
                  ><a
                    :href="element"
                    target="_blank"
                    class="text-primary fw-600"
                    >Open document</a
                  ></span
                >
                <span v-else-if="key == 'quote_url'"
                  ><a
                    :href="element"
                    target="_blank"
                    class="text-primary fw-600"
                    >Open quote</a
                  ></span
                >
                <span v-else>{{ element }}</span>
              </template>
            </dd>
          </dl>
        </template>
      </b-card>
    </template>
  </div>
</template>
<script>
import { fnSnakeToTitle } from '../../services/sharedFn.service'

export default {
  name: 'WDVsaQuoteLeadsLogs',
  props: {
    vsaLogs: {
      type: Array,
      default: []
    }
  },
  computed: {
    /**
     * Remove mutates of data
     */
    getSortedArray() {
      let vsaLogs = this.vsaLogs
      let removeMutate = JSON.parse(JSON.stringify(vsaLogs))
      return removeMutate.reverse()
    }
  },
  methods: {
    fnGetSnakeToTitle(str) {
      return fnSnakeToTitle(str)
    }
  }
}
</script>
